export default {
    schoolOverview: '',
    coursewareResource: '',
    activityProportopn: '',
    attendance: '',
    achievementAnalysis: '',
    departmentResource: '',
    departmentResourceDetails:''
  }
  


// WEBPACK FOOTER //
// ./src/store/situation/states.js